import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import RedirectToast from 'Redesign_Funnel/components/RedirectToast';

import fetchEmailVerificationStatus from 'Services/VerifyAccount/Validate';
import { getApplication } from 'Services/Applications/Application';
import storeApplicationAction from 'Actions/application';
import {
  featureFlagsPropTypeShape, withConfig,
} from 'Contexts/Config';
import { GlobalLoadingCaller } from 'Utils/GlobalLoading';
import { isMobileDesign } from 'Utils/mobile';
import { deepLink } from 'Utils/deepLink';
import { withMenuControls, menuPropTypes } from 'Contexts/Menu';

import Urls, { PageStatus } from './Urls';

export class PrivateRouteComponent extends Component {
  static isLoggedIn = () => {
    if (localStorage.email === undefined || localStorage.kueski_session === undefined) {
      return false;
    }
    return true;
  };

  constructor(props) {
    super(props);
    this.state = {
      app: {},
      changeUrl: false,
      init: true,
      redirectMessageIsOpen: false,
      urlChange: '',
    };

    this.redirectToOverriddenRoute = this.redirectToOverriddenRoute.bind(this);
    this.showRedirectMessage = this.showRedirectMessage.bind(this);
    this.hiddeRedirectMessage = this.hiddeRedirectMessage.bind(this);
    this.redirectToVerifyEmail = this.redirectToVerifyEmail.bind(this);
  }

  componentDidMount() {
    const {
      status,
      menuActions,
    } = this.props;

    if (!PrivateRouteComponent.isLoggedIn()) {
      if (status === 'loan') deepLink.set(`${window.location.pathname}${window.location.search}`);
      this.setState({
        changeUrl: true,
        init: false,
        urlChange: Urls.landing,
      });
      return;
    }

    getApplication().then((app) => {
      if (app.application_process_id !== null) {
        const { storeApplication } = this.props;

        storeApplication({
          applicationId: app.application_process_id,
          channel: app.channel,
          customerId: app.customer_id,
          customerName: app.customer_name,
          productType: app.payment_type,
        });
        if (status === '' || app.status === status || status === 'loan') {
          this.setState({
            app,
            init: false,
          });
        } else {
          this.setState({
            changeUrl: true,
            init: false,
            urlChange: PageStatus[app.status],
          });
        }
        menuActions.setUserName(app.customer_name);
        return;
      }

      if (status && status !== 'loan') {
        this.setState({
          changeUrl: true,
          init: false,
          urlChange: Urls.landing,
        });
      } else {
        this.setState({
          app,
          init: false,
        });
      }
    });
  }

  componentDidUpdate() {
    this.redirectToVerifyEmail();
  }

  redirectToVerifyEmail() {
    const isMobile = isMobileDesign();

    const {
      features,
      pushConnected,
    } = this.props;
    const {
      VERIFY_ACCOUNT: isVerifyEmail,
    } = features;

    if (isVerifyEmail && !isMobile && PrivateRouteComponent.isLoggedIn()) {
      fetchEmailVerificationStatus()
        .then((response) => {
          if (response && response.status === 'success') {
            const isEmailVerified = response.data.is_email_verified;
            const forceVerifyEmail = response.data.force_verify_email;

            if (!isEmailVerified && forceVerifyEmail) {
              pushConnected(`${Urls.verifyAccount}/?send_email=true`);
            }
          }
        });
    }
  }

  redirectToOverriddenRoute() {
    const { pushConnected } = this.props;
    pushConnected(Urls.overridden);
  }

  hiddeRedirectMessage() {
    this.setState(() => ({
      redirectMessageIsOpen: false,
    }));
  }

  showRedirectMessage() {
    const { redirectMessageIsOpen } = this.state;
    if (redirectMessageIsOpen) return;

    RedirectToast({
      message: 'Fuiste redirigido a otro sitio de Kueski',
      onClose: this.hiddeRedirectMessage,
    });

    this.setState(() => ({
      redirectMessageIsOpen: true,
    }));
  }

  render() {
    const {
      init,
      changeUrl,
      urlChange,
      app,
    } = this.state;

    const {
      component: Comp,
      pushConnected,
      ...rest
    } = this.props;

    if (init) {
      return <GlobalLoadingCaller queryKey={['PrivateRoute']} />;
    }

    if (changeUrl) {
      window.location.assign(urlChange);
      return '';
    }

    return (
      <>
        <Route {...rest} render={params => <Comp {...params} app={app} />} />
      </>
    );
  }
}

PrivateRouteComponent.propTypes = {
  component: PropTypes.func.isRequired,
  features: featureFlagsPropTypeShape.isRequired,
  isPusherRedirectionEnabled: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
  path: PropTypes.string,
  pushConnected: PropTypes.func.isRequired,
  status: PropTypes.string,
  storeApplication: PropTypes.func.isRequired,
  ...menuPropTypes,
};

PrivateRouteComponent.defaultProps = {
  isPusherRedirectionEnabled: true,
  path: '',
  status: '',
};

const mapStateToProps = (state) => {
  const states = {
    isPusherRedirectionEnabled: state.pusher?.isRedirectionEnabled,
    router: state.router,
  };
  return states;
};

const mapDispatchToProps = dispatch => bindActionCreators({
  pushConnected: push,
  storeApplication: storeApplicationAction,
}, dispatch);

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withMenuControls,
  withConfig,
)(PrivateRouteComponent);
